import React from 'react';
import Modal from 'react-modal';
import './styles.scss';

const ClearDayModal = ({ closeModal, handleConfirm, data }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    closeModal();
  };

  return (
    <Modal className="modal-alert delete-task-modal" isOpen onRequestClose={handleClose} contentLabel="Clear Day Modal" ariaHideApp={false}>
      <h2 className="modal-header">
        <img src="/images/alert-icon.svg" alt="" />
        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Confirm time slots deletion</h3>
        <p>Are you sure you want to delete all the time slots from the day ? This action cannot be undone.</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default ClearDayModal;
